import styled from "styled-components";
import colors from "../../../../../../../../../styles/colorPalette";

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: left;
  height: 100%;
  font-family: "OpenSansRegular";
  font-size: 18px;
  font-weight: 400;
  color: ${colors.gray6};
  transition: all 0.5s;
  background: transparent;
  @media (max-width: 1366px) {
    width: 80px;
    font-size: 12px;
  }
`;
